<template src="./index.html">
</template>
<script>
	import router from '@/router';
	import Axios from 'axios';
	import {
		hex_md5
	} from '../../../assets/js/md5'
	import {
		getUserInfo,
		moduleInfo
	} from '../../../api/home.js'
	import confing from '../../../../configHttp.js'
    import configHttp from '../../../../configHttp';
	const axios = Axios.create({});
	export default {
		name: "Login",
		data() {
			return {
				showpassword: false,
				show: true,
				count: '',
				timer: null,
				loginform: {
					phone: "",
					email: "",
					password: "",
					sign: "",
					type: 1
				},
				loginformrules: {
					phone: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '密码未填写，请填写完整',
						trigger: 'blur'
					}],
					sign: [{
						required: true,
						message: '验证码未填写，请填写完整',
						trigger: 'blur'
					}]
				},
				countemail: "",
				showemail: true,
				timeremail: null,
				// 此段参数用来启动页面的分区模块登录功能
				saasLoginStatus: {
					saas: false, //saas
					nssb: false, //纳税申报
					iinv: false, //进项
					oinv: false, //销项
					ei: false //电票
				},
				// 各后端登录地址
				url: {
					saas: confing.sassURL + "base/sys/user/login", //saas
					nssb: confing.baseURL + "login", //纳税申报
					iinv: "", //进项
					oinv: "", //销项
					ei: confing.eiURL //电票
				},
				loginTimer: null,
				confing: confing
			}
		},
		created() {
			localStorage.removeItem("saasLoginStatus");
			localStorage.removeItem("nstoken");
			localStorage.removeItem("token");

			this.projectName = this.confing.projectName
			this.enableFamilyLogin = this.confing.enableFamilyLogin
			this.familyLoginUrl = this.confing.familyLoginUrl
			var _self = this
			document.onkeydown = function(e) {
				var key = window.event.keyCode
				if (key == 13) {
					_self.forlogin() // 登录的方法
				}
			}

			if (this.enableFamilyLogin) {
				let param = this.getRequestParam();
				let requestParamToken = param["token"];
				let portalLogin = localStorage.getItem("portalLogin");
				localStorage.clear();
				if (this.enableFamilyLogin && (this.projectName == "PRODUCT" || this.projectName == '')) { // 产品单点登录跳转
					if (requestParamToken || portalLogin == "true") {
						this.productRedirect();
					}
				}
			}



		},
		mounted() {

		},
		beforeDestroy() {
			clearInterval
		},
		methods: {
			clearInterval() {
				this.show = true;
				clearInterval(this.timer);
				this.timer = null;
				this.showemail = true;
				clearInterval(this.timeremail);
				this.timeremail = null;
			},
			Sasslogin(url, saasData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: url.saas,
						withCredentials: true,
						data: saasData,
					}).then((response) => {
						if (response.data.success) {
							this.saasLoginStatus.saas = true; // 登录成功的地址将参数调整为true
						}
						resolve(true);
					}).catch((error) => {
						resolve(true);
					})
				})
			},
			getmewaucode(list) {
				var meaurouter = []

				function getmewaucode(list) {
					list.forEach(item => {
						if (item.resCode) {
							meaurouter.push(item.resCode)
						}
						if (item.children && item.children.length > 0) {
							getmewaucode(item.children)
						}
					})
				}
				getmewaucode(list)
				return meaurouter
			},
			nssblogin(url) {
				var loading = this.$loading({
					lock: true,
					text: '登陆中……',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				return new Promise((resolve, reject) => {
					// 登录纳税申报
					let loginData = {
						"username": this.loginform.phone,
						"password": this.loginform.password
					};
					axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
					axios({
						method: "post",
						url: url.nssb,
						withCredentials: true,
						data: JSON.stringify(loginData),
					}).then((response) => {
						loading.close()
						// code = 1 是成功
						if (response.data.code == 1) {
							this.saasLoginStatus.nssb = true;
							localStorage.setItem("nstoken", response.data.data);
							localStorage.setItem("token", response.data.data);
							getUserInfo().then(res => {
                                /*if (res.data.data.menus) {
                                    if (configHttp.homePage && configHttp.homePage === "1") {
                                        res.data.data.menus = res.data.data.menus.filter(item => item.resCode !== "home");
                                    } else {
                                        res.data.data.menus = res.data.data.menus.filter(item => item.resCode !== "HomePageNew");
                                    }
                                }*/
								localStorage.setItem('meausout', JSON.stringify(res.data.data
									.menus))
								res.data.data.userInfo.parentName = res.data.data.parentName
								let meaurouter = this.getmewaucode(res.data.data.menus)
								let newmeaus = res.data.data.menus
								let ConfigurationCentermeau = []
								newmeaus.forEach(item => {
									if (item.resCode == "ConfigurationCenter") {
										ConfigurationCentermeau = JSON.parse(JSON
											.stringify(item)).children
										item.children = []
									}
								})
								localStorage.setItem("resources", JSON.stringify(res.data.data
									.resources))
								localStorage.setItem("meaurouter", meaurouter)
								localStorage.setItem("meaus", JSON.stringify(newmeaus))
								localStorage.setItem("ConfigurationCentermeau", JSON.stringify(
									ConfigurationCentermeau))
								localStorage.setItem("userInfo", JSON.stringify(res.data.data
									.userInfo))
								localStorage.setItem("userRoles", JSON.stringify(res.data.data
									.roles))
								localStorage.setItem("suosq", res.data.data.suosq)
								localStorage.setItem("nssbCompany", res.data.data.nssbCompany)
								resolve(true);
							}).catch((error) => {})
						} else {
							this.$message.error(response.data.msg)
						}
					}).catch((error) => {})
				})
			},
			syslogin(url) {
				// 登录电票
				return new Promise((resolve, reject) => {
					let eiLoginData = {
						"userCode": this.loginform.phone,
						"password": this.loginform.password,
						"sign": "1"
					};
					axios({
						method: "post",
						url: url.ei + "sys/login",
						withCredentials: true,
						data: JSON.stringify(eiLoginData),
					}).then((response) => {
						if (response.data.success) {
							// 首先正常通过接口登录获取token
							localStorage.setItem("token", response.data.obj.token);
							// 拼接电票开发过的财税管家的单点登录所需参数
							let authParam = {
								"userId": response.data.obj.user.id,
								"companyId": response.data.obj.user.currCompany.id,
								"token": response.data.obj.token
							}
							// 请求电票单点登录接口
							axios({
								method: "post",
								url: url.ei + "sync/auth",
								withCredentials: true,
								data: JSON.stringify(authParam),
							}).then((response) => {
								if (response.data.success) {
									// 成功后将对应模块的权限调整为true，并保存对应数据
									this.saasLoginStatus.ei = true;
									localStorage.setItem("eiAuth", response.data.obj);
								}
								resolve(true);
							}).catch((error) => {
								resolve(true);
							})
						} else {
							resolve(true);
						}
					}).catch((error) => {
						resolve(true);
					})

				})
			},
			forlogin() {
				this.$refs['loginform'].validate(async (valid) => {
					if (valid) {
						// 需要一个获取url的方法，比如进项，销项，纳税申报的后端地址
						let url = this.url;
						let password = hex_md5(this.loginform.password)
							.toUpperCase(); // 2.0所有登录密码都会在前端md5处理
						let saasData = "userName=" + this.loginform.phone + "&password=" + password +
							"&code="; // saas系列登陆用的请求参数，进项，销项都是一样的

						// let Sassstatus = await this.Sasslogin(url, saasData)
						// if (Sassstatus) {
						let nssbstatus = await this.nssblogin(url)
						if (nssbstatus) {
                            let path = "/home";
                            if (configHttp.homePage && configHttp.homePage === "1") {
                                path = "HomePageNew";
                            }
							this.$router.push({
								path: path,
							});
							// moduleInfo({
							// 	"username": this.loginform.phone,
							// 	"password": this.loginform.password
							// }).then(res => {
							// 	localStorage.setItem("moduleInfo", JSON.stringify(res.data))
							// 	// if (this.$notemptyandnull(res.data) || nssbstatus) {
							// 	// 	this.$router.push({
							// 	// 		path: "/homepage",
							// 	// 	});
							// 	// }
							// 	this.$router.push({
							// 		path: "/home",
							// 	});
							// })
							// let Sassstatus = await this.syslogin(url)
							// if (Sassstatus) {
							// 	let state = false
							// 	for (let x in this.saasLoginStatus) {
							// 		if (this.$notemptyandnull(this.saasLoginStatus[x])) {
							// 			state = true
							// 		}
							// 	}
							// 	if (state) {
							// localStorage.setItem("saasLoginStatus", JSON.stringify(this
							// 	.saasLoginStatus));

							// 	} 

							// }
						}
						//}
					}
				})

				// 此处的所有方法需要整合进平台登录系统的请求内
				// 登录saas环境

			},
			/* 登录验证码倒计时 */
			getCode() {
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
				}
			},
			getCodeemail() {
				const TIME_COUNT = 120;
				if (!this.timeremail) {
					this.countemail = TIME_COUNT;
					this.showemail = false;
					this.timeremail = setInterval(() => {
						if (this.countemail > 0 && this.countemail <= TIME_COUNT) {
							this.countemail--;
						} else {
							this.showemail = true;
							clearInterval(this.timeremail);
							this.timeremail = null;
						}
					}, 1000);
				}
			},
			sendSMS() {
				if (this.emptyandnull(this.loginform.phone) || !this.show) {
					return false
				}
				if (!(/^1[3456789]\d{9}$/.test(this.loginform.phone))) {
					this.$message.error("手机号格式不正确")
					return false;
				}
				send(this.loginform).then(res => {
					if (res.data.code == "200") {
						this.$message.success(res.data.message)
						this.getCode()
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			getRequestParam() { //  获取请求后面的参数
				var requestParam = new Object();
				if (location.href.indexOf('?') != -1) {
					var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
					var str = url.substr(1);
					let strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[
						1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
					}
				}
				return requestParam;
			},
			async productRedirect() { // 产品单点登录
				localStorage.setItem("portalLogin", "true");
				let requestParam = this.getRequestParam();
				let token = requestParam['token'];
				if (token && token.length > 0) {
					localStorage.setItem('token', token);
				} else {
					token = localStorage.getItem('token')
				}

				if (token && token != "null") {
					axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
					axios({
						method: "post",
						url: this.confing.baseURL + 'familyLogin?token=' + token,
						withCredentials: true,
						data: "",
					}).then((response) => {
						if (response.data.code == 1) {
							this.saasLoginStatus.nssb = true;
							localStorage.setItem("nstoken", response.data.data);
							localStorage.setItem("token", response.data.data);
							getUserInfo().then(res => {
								localStorage.setItem('meausout', JSON.stringify(res.data.data
									.menus))
								res.data.data.userInfo.parentName = res.data.data.parentName
								let meaurouter = this.getmewaucode(res.data.data.menus)
								let newmeaus = res.data.data.menus
								let ConfigurationCentermeau = []
								newmeaus.forEach(item => {
									if (item.resCode == "ConfigurationCenter") {
										ConfigurationCentermeau = JSON.parse(JSON
											.stringify(item)).children
										item.children = []
									}
								})
								localStorage.setItem("resources", JSON.stringify(res.data.data
									.resources))
								localStorage.setItem("meaurouter", meaurouter)
								localStorage.setItem("meaus", JSON.stringify(newmeaus))
								localStorage.setItem("ConfigurationCentermeau", JSON.stringify(
									ConfigurationCentermeau))
								localStorage.setItem("userInfo", JSON.stringify(res.data.data
									.userInfo))
								localStorage.setItem("userRoles", JSON.stringify(res.data.data
									.roles))
								localStorage.setItem("suosq", res.data.data.suosq)
								localStorage.setItem("nssbCompany", res.data.data.nssbCompany)

								this.$router.push({
									path: "/home",
								});
							}).catch((error) => {
								window.location.href = this.familyLoginUrl;
							})
						} else {
							this.$message.error(response.data.msg)
							window.location.href = this.familyLoginUrl;
						}
					});
				} else {
					window.location.href = this.familyLoginUrl;
				}

			},

		}
	};
</script>



<style scoped lang="less">
	@import url('./index.less');
</style>